import VistoriaEpiRepository from '@/shared/http/repositories/business/surveyEquipment'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'
import modalepisurvey from '@/views/private/Survey/components/modalepisurvey/modalepisurvey.vue'

export default {
  mixins: [ActionsForm],
  props: ['dataEqp', 'idvistoria'],
  components: {
    modalepisurvey
  },
  plugins: [
    { src: '~/plugins/jszip', mode: 'client' }
  ],
  name: 'eqpsurvey',
  data () {
    return {
      dataEquipam: [],
      CA: '',
      headTable: ['Título', 'Ca', 'Status', 'Ação'],
      dataStatus: {
        Mensagem: '',
        value: false
      },
      modal: {
        Obs: false,
        ContinuarButton: true,
        conforme: false
      },
      Equipamento: {},
      changeModal: 0,
      notConfome: false,
      testeimg: [],
      detailsImg: null,
      baseImgCompleta: [],
      checekdAllImg: false,
      EquipamentoEdit: null,
      imgEqp: [],
      Allimg: [],
      dadosAll: [],
      disableButtonDowload: true,
      incoformidade: []
    }
  },
  methods: {
    showModal (obj) {
      this.$refs.modalepi.showModal(obj)
    },
    onLoad () {
      this.onLoadEquipamento()
    },
    backImgDetails () {
      this.changeModal = 1
    },
    sendStatusSurvey () {
      this.changeModal = 1
    },
    showDetailsImg (obj) {
      this.changeModal = 2
      this.detailsImg = obj
    },
    img (e) {
      let UrlConvert = URL.createObjectURL(e.target.files[0])
      let obj = {
        data: e.target.files[0],
        url: UrlConvert
      }
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let img = new FormData()
      img.append('img', obj.data)
      VistoriaEpiRepository.SetImg(this.EquipamentoEdit.id, img, conf)
        .then(Reponse => console.log(Reponse))
        .catch(Error => console.log(Error))
      this.baseImgCompleta.push(obj)
    },
    changeButtonContinua () {
      this.modal.ContinuarButton = !this.modal.ContinuarButton
    },
    deleteImg (value) {
      this.testeimg = this.testeimg.filter((Element) => Element !== value)
    },
    edit (obj) {
    },
    setStatus (obj) {
      let status = this.dadosAll.filter((Element) => Element.epi.id === obj.id)
      if (status[0].conforme) return true
    },
    getStatusClass (obj) {
      let status = this.dadosAll.filter((Element) => Element.epi.id === obj.id)
      if (status[0].naoSeAplica) {
        return 'notStatus'
      } else {
        return 'conforStatus'
      }
    },
    getAplicar (obj) {
      if (obj.naoSeAplica) return false
      return true
    },
    getStatus (obj) {
      if (obj.conforme) {
        return true
      } else {
        return false
      }
    },
    getAplicarColorTable (obj) {
      if (obj.naoSeAplica) {
        this.Equipamento.font = 'rgb(255 96 0 / 92%)'
        return this.Equipamento.font
      } else if (obj.conforme) {
        this.Equipamento.font = 'rgb(19, 59, 26)'
        return this.Equipamento.font
      } else {
        this.Equipamento.font = 'rgb(106, 106, 106)'
        return this.Equipamento.font
      }
    },
    getAplicarDescricaoTable (obj) {
      if (obj.naoSeAplica) {
        this.Equipamento.descricao = 'NÃO SE APLICA'
        return this.Equipamento.descricao
      } else if (obj.conforme) {
        this.Equipamento.descricao = 'CONFORME'
        return this.Equipamento.descricao
      } else {
        this.Equipamento.descricao = 'NÃO CONFORME'
        return this.Equipamento.descricao
      }
    },
    getAplicarColorFundoTable (obj) {
      if (obj.naoSeAplica) {
        this.Equipamento.color = '#ffeadc'
        return this.Equipamento.color
      } else if (obj.conforme) {
        this.Equipamento.color = '#cbe9cf'
        return this.Equipamento.color
      } else {
        this.Equipamento.color = 'rgb(192, 192, 192)'
        return this.Equipamento.color
      }
    },
    onLoadEquipamento () {
      loading.push()
      let dados = []
      this.dataEquipam = []
      VistoriaEpiRepository.GetByVistoria(this.dataEqp.id, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then(Response => {
          for (let i = 0; i < Response.data.data.length; i++) {
            dados.push(Response.data.data[i])
            this.dataEquipam.push(Response.data.data[i])
          }
          this.$refs.tableGrid.LoadAllByData(Response)
          this.$refs.tableGrid.total = dados.length
          this.dadosAll = Response.data.data
          loading.pop()
        })
        .catch(Error => this.onException(Error))
    }
  },
  FormatDate (value) {
    return Tools.FormatDate(value)
  },
  formatStatusVistoria (value) {
    if (value === 0) return 'Não Enviado'
    if (value === 1) return 'Aguardando Aprovação'
    if (value === 2) return 'Aguardando Correção'
    if (value === 3) return 'Aprovado'
  },
  checkQuantityObj (obj) {
  },
  onChange (obj) {
  },
  onDelete (obj) {

  }
}



// WEBPACK FOOTER //
// ./src/views/private/Survey/components/eqpSurvey/eqpSurvey.js